import J_NA from './NA';
import J_EU from './EU';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es'];

    return <>{EU_SITES?.includes(locale) ? <J_EU /> : <J_NA />}</>;
}
